import {Brick, registerBrick} from 'olympe';

/**
 * Create a list of filter
 */
export default class ERAddFilterToBody extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} body
     * @param {string} field
     * @param {*} value
     * @param {string} operator
     * @param {*} group
     * @param {function(*)} setBody
     */
    update($, [body, field, value, operator, group], [setBody]) {
        const newBody = {
            ...body,
            filters: [
                ...(body.filters ? body.filters : []),
                {
                    ...(field ? {field: field} : {}),
                    ...(value ? {value: value} : {value: ''}),
                    ...(operator ? {operator: operator} : {}),
                    ...(group ? {group: group} : {}),
                },
            ],
        };
        setBody(newBody);
    }
}

registerBrick('01867e604c59694f8879', ERAddFilterToBody);
